module.exports = __webpack_public_path__ + "static/media/timeline-answered.4ecaa0b2.svg";